import { render, staticRenderFns } from "./receive-status.vue?vue&type=template&id=585a298c&scoped=true&"
import script from "./receive-status.vue?vue&type=script&lang=js&"
export * from "./receive-status.vue?vue&type=script&lang=js&"
import style0 from "./receive-status.vue?vue&type=style&index=0&id=585a298c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a298c",
  null
  
)

export default component.exports